import React from 'react';

import {BANK_TYPES} from '../../../constants/typesMessages';
import {useChatStore} from '../../../store/slices/chatStore';
import BankAccountInput from '../BankAccountInput';
import BankBranchInput from '../BankBranchInput';
import BankSelector from '../BankSelector';
import './BankDataFields.style.scss';

const BankDataFields = (props) => {
  const responseFlow = useChatStore((state) => state.responseFlow);

  /**
   * Escolher o input de acordo com o tipo de entrada de dado bancário esperado
   */
  return (
    <div
      data-aut-test="fields-bank-data"
      data-testid="fields-bank-data"
      className="input-content"
    >
      {responseFlow === BANK_TYPES.BANK_NAME && <BankSelector {...props} />}
      {responseFlow === BANK_TYPES.BANK_BRANCH && (
        <BankBranchInput {...props} />
      )}
      {responseFlow === BANK_TYPES.BANK_ACC && <BankAccountInput {...props} />}
    </div>
  );
};

export default BankDataFields;
